const constants = {
    STORAGE_KEY_NAME: 'app-na-blog',
    STORE_TIME_OUT: 1000
};

export default constants;
